import React from "react";
import { CrestSVG } from "./CrestSVG";

// Backwards-compatible preview used on the Family Tree canvas + shared page.
// Now renders the rich SVG crest.
export function FamilyCrestPreview({ crest, size = 180 }) {
  return <CrestSVG crest={crest} size={size} />;
}

// Kept for import compatibility. The full editor now lives in FamilyCrestStudio.
export function FamilyCrestBuilder({ value }) {
  return (
    <div className="crest-preview-panel">
      <FamilyCrestPreview crest={value} />
    </div>
  );
}
